module.exports = {"$schema":"http://json-schema.org/draft-04/schema#","title":"memos","link":"transaction-memos","description":"Array of memos to attach to the transaction.","type":"array","items":{"$ref":"memo"}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ripple-lib/dist/npm/common/schemas/objects/memos.json
// module id = ayWT
// module chunks = 1